import React, { useContext, useEffect, useState } from 'react'
import {AiFillCloseCircle} from 'react-icons/ai'
import {IoMdArrowDropdown} from 'react-icons/io'
import {IoChevronBackOutline} from  'react-icons/io5'
import {BiCheck} from  'react-icons/bi'

import Renderif from '../../components/renderif'
import DropDown, { DropDownOption } from '../../components/dropdown'
import BVCalendar from '../../components/calendar'
import { Service } from '../../services/api'
import { AuthContext } from '../../context/auth_context'

import ApiCalendar from "react-google-calendar-api";
import { AlertContext } from '../../context/alert_context'
const config = {
    clientId: "120251394725-odcgh221pgbild6n02k22a7qjsnls72i.apps.googleusercontent.com",
    apiKey: "AIzaSyDmACRaWHwMi8m8t3ivDh83o49N7XJS-aM",
    scope: "https://www.googleapis.com/auth/calendar",
    discoveryDocs: [
      "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
    ],
  };
  const apiCalendar = new ApiCalendar(config);


export default function SelectProfile({...props}) {

    let date = new Date();
    date.setDate(date.getDate() + 1)

    const {user,changeUser} = useContext(AuthContext)
    console.log(user)
    const {notify} = useContext(AlertContext)
    const [state, setState] = useState({
        step:0,
        selected_date:null,
        specialists:[],
        specialists_pisco:[],
        specialists_couch:[],
        selected_speciality:null,
        selected_specialist:null,
        selected_day:date,
        selected_time:'',
        selected_daytime:null,
        description:'',
        family:[
            {
                id:1,
                img:'https://source.boringavatars.com/beam/120/Stefan?colors='+Math.floor(Math.random()*16777215).toString(16)+',f4a261',
                name:'Laurie',
                lastname:'Santos',
                relationType:'Madre',
                email:'example@dominio.com',
                phone:'12 23 45 56 78'
            },
            {
                id:2,
                img:'https://source.boringavatars.com/beam/120/Stefan?colors='+Math.floor(Math.random()*16777215).toString(16)+',f4a261',
                name:'Laurie',
                lastname:'Santos',
                relationType:'Papa',
                email:'example@dominio.com',
                phone:'12 23 45 56 78'
            },
            {
                id:3,
                img:'https://source.boringavatars.com/beam/120/Stefan?colors='+Math.floor(Math.random()*16777215).toString(16)+',f4a261',
                name:'Laurie',
                lastname:'Santos',
                relationType:'Hermano',
                email:'example@dominio.com',
                phone:'12 23 45 56 78'
            },
        ],

        selected_family:[
            {
                id:1,
                img:'https://source.boringavatars.com/beam/120/Stefan?colors='+Math.floor(Math.random()*16777215).toString(16)+',f4a261',
                name:'Laurie',
                lastname:'Santos',
                relationType:'Madre',
                email:'example@dominio.com',
                phone:'12 23 45 56 78'
            },
        ]

    })
    useState(()=>{
        const init = async () => {
            const family = await Service('GET', 'Family');
        
            if(family.status === 200){

                let limit = family.data.length - 4 < 0 ? 0 : family.data.length - 4
                family.data.map((item)=>{
                    item.photo = 'https://source.boringavatars.com/beam/120/Stefan?colors='+Math.floor(Math.random()*16777215).toString(16)+',f4a261'
                })
                //setState({...state, family:family.data.slice(limit), member_active:family.data[0]})
            }
        };
        init();
        return () => {}
    },[])



 
  




  return (
    <div className='overlay d-flex justify-content-center align-items-center'>
     
        <Renderif isTrue={state.step === 0}>
            <div className='bv-modal shadow'>

                <div className='px-3 pt-3 pb-4 d-flex align-items-center'>
                    
                    <div className='f-16 text-gray bold'></div>
                    <div className='col'></div>
                    <div className='bv-icon bv-icon--mid cursor-pointer' onClick={()=>{
                        props.onCancel()
                    }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                </div>



                <div className='text-gray bold text-center f-16 px-4 py-1'>
                    ¿ Cúal es tu perfil ?
                </div>

                <div className='d-flex justify-content-center flex-wrap p-4'>
                    {user?.profiles.map((item, i) => {

                        let photo = 'https://source.boringavatars.com/beam/120/Stefan?colors=C0EFFF,f4a261';
               
                        if(item.photo === null){
                            photo = 'https://source.boringavatars.com/beam/120/Stefan?colors=C0EFFF,f4a261';
                        }else{
                            photo = item.phone;
                        }

                        return (
                        <div key={i} className='d-flex flex-column  align-items-center'>
                            <div className={`avatar avatar--xl cursor-pointer mx-2`} style={{'backgroundImage': 'url('+item.photo+')'}} onClick={async ()=>{

                                let set_profile = await changeUser({profile:item})
                                if(set_profile){
                                    props.onCancel();
                                    notify({title:'Perfil', message:'Hola!,'+item.firstname, type:'success'})
                                }else{
                                    notify({title:'Lo sentimos!', message:'No puedes a cambiar a este perfil', type:'error'})
                                }
                          

                             }}></div>
                            <div className='text-gray f-12 text-center no-wrap px-1'>{item.firstname}</div>
                        </div>
                        )
                        
                    })}
                </div>
                
                <div className='d-flex b-top p-4'>
                
                    <div className='col'></div>
                    <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={()=>{
                         props.onCancel()
                    }}>Cancelar</div>
                    {/* <div className='bv-pill bv-pill--primary cursor-pointer' onClick={()=>{
                            setState({...state, step:state.step + 1})
                    }}>Continuar</div> */}
                </div>
            </div>
        </Renderif>
    
    </div>
  )
}
